import React, { useState, useEffect } from 'react'
import '../../home-style.scss'
import { FetchHomeAvgGraphBysortNew, fetchGraphV2aggr } from '../../../../services/api'
import dayjs from 'dayjs'
import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import CloseIcon from '@mui/icons-material/Close'
import DialogContentText from '@mui/material/DialogContentText'
import IconButton from '@mui/material/IconButton'
import usePrgraphStyles from './styles'
import PrGraphFilter from '../PrGraphFilter/PrGraphFilter'
import PrGraphContainer from '../PrGraphContainer/PrGraphContainer'

const Prgraph = ({ token }) => {
  const classes = usePrgraphStyles()
  const [technicalFromDate, setTechnicalFromDate] = React.useState(
    dayjs(new Date()).subtract(29, 'day')
  )
  const [technicalToDate, setTechnicalToDate] = React.useState(
    dayjs(new Date())
  )
  const [totalEnergygraphDuration, settTotalEnergyGraphDuration] =
    useState('1m')
  const [screenHeight, setScreenHeight] = useState(window.innerHeight)
  const [mapTotalenergySeries, setMapTotalenergySeries] = React.useState([])
  const [graphTotalType] = useState('PR')
  const [open, setOpen] = useState(false)
  const [openTable, setOpenTable] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [isData, setIsData] = useState(false)

  useEffect(() => {
    const handleResize = () => {
      setScreenHeight(window.innerHeight)
    }
    window.addEventListener('resize', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  useEffect(() => {
    handleTotalenergyGraph('PR', '1m', technicalFromDate)
  }, [])

  useEffect(() => {
    handleTotalenergyGraph('PR', totalEnergygraphDuration, technicalFromDate)
  }, [technicalFromDate, technicalToDate])

  const handleOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }

  const [chartData, setChartData] = useState({
    series: [
      {
        name: 'Net Profit',
        data: [44, 55, 57, 56, 61, 58, 63, 60, 66],
      },
    ],
    options: {
      chart: {
        type: 'bar',
        loading: isLoading,
        height: 350,
        zoom: {
          enabled: false,
        },
        toolbar: {
          export: {
            csv: {
              filename: 'TotalEnergy',
              columnDelimiter: ',',
              headerCategory: 'Date',
              headerValue: 'value',
              dateFormatter(timestamp) {
                return new Date(timestamp).toDateString()
              },
            },
            svg: {
              filename: 'TotalEnergy',
            },
            png: {
              filename: 'TotalEnergy',
            },
          },
        },
      },
      legend: {
        show: false,
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: '55%',
          endingShape: 'rounded',
        },
      },
      dataLabels: {
        enabled: true,
        enabledOnSeries: [1],
      },
      stroke: {
        show: true,
        width: 2,
        colors: ['transparent'],
      },

      fill: {
        colors: ['#5968B7'],
        gradient: {
          type: 'vertical',
          shadeIntensity: 0.5,
          gradientToColors: undefined, // optional, if not defined - uses the shades of same color in series
          inverseColors: true,
          opacityFrom: 1,
          opacityTo: 0,
          stops: [0, 100],
          colorStops: [],
        },
      },
      xaxis: {
        type: 'category',
        floating: false,
        labels: {
          show: true,
          rotate: -45,
          rotateAlways: true,
          hideOverlappingLabels: true,
          showDuplicates: false,
          trim: false,
          minHeight: undefined,
          maxHeight: 120,
          style: {
            colors: [],
            fontSize: '12px',
            fontFamily: 'Helvetica, Arial, sans-serif',
            fontWeight: 400,
            cssClass: 'apexcharts-xaxis-label',
          },
          offsetX: 0,
          offsetY: 0,
          format: 'dd/MM',
          formatter: function (value, timestamp, opts) {
            return dayjs(value).format('DD-MM')
          },
          datetimeUTC: false,
          datetimeFormatter: {
            year: 'yyyy',
            month: "MMM 'yy",
            day: 'dd MMM',
            hour: 'HH:mm',
          },
        },
        tooltip: {
          enabled: true,
          formatter: function (value, timestamp, opts) {
            return dayjs(value).format('MMMM-DD')
          },
          offsetY: 0,
        },
      },
      tooltip: {
        enabled: true,
        x: {
          show: true,
          format: 'dd MMM',
          formatter: function (value, opts) {
            return dayjs(
              opts.w.config.series[opts.seriesIndex].data[opts.dataPointIndex].x
            ).format('DD-MMMM')
          },
        },
      },
      grid: {
        yaxis: {
          lines: {
            offsetX: -30,
          },
        },
        padding: {
          left: 20,
        },
      },
    },
  })

  const handleGraphupdateOptions = (newOptions) => {
    setChartData((prevOptions) => ({
      ...prevOptions,
      options: {
        ...prevOptions.options,
        xaxis: { ...newOptions.xaxis }, // Merge xaxis options
        tooltip: { ...newOptions.tooltip }, // Merge tooltip options
      },
    }))
  }

  const handleChooseDate = (value, type) => {
    let subtraction
    let subType

    switch (totalEnergygraphDuration) {
      case 'year':
        subtraction = 11
        subType = 'month'
        break
      case '1m':
        subtraction = 29
        subType = 'day'
        break
      case '3m':
        subtraction = 2
        subType = 'month'
        break
      case '6m':
        subtraction = 5
        subType = 'month'
        break
      case 'mtd':
        subtraction = 0
        subType = 'month'
        break
      case 'ytd':
        subtraction = 0
        subType = 'month'
        break
      case 'custom':
        subtraction = 0
        subType = 'day'
        break
      default:
        break
    }

    if (type === 'from') {
      if (totalEnergygraphDuration === 'custom') {
        setTechnicalFromDate(value)
      } else {
        const yearData = dayjs(value).add(subtraction, subType)
        setTechnicalFromDate(value)
        const currentDate1y = dayjs()
        const isFuture1y = yearData.isAfter(currentDate1y)
        if (isFuture1y) {
          const previous1yData = dayjs(dayjs(new Date())).subtract(
            subtraction,
            subType
          )
          setTechnicalFromDate(previous1yData)
          setTechnicalToDate(dayjs(new Date()))
        } else {
          setTechnicalToDate(dayjs(new Date()))
        }
      }
    } else if (type === 'to') {
      if (totalEnergygraphDuration === 'custom') {
        setTechnicalToDate(value)
      } else {
        const yearData = dayjs(value).subtract(subtraction, subType)
        setTechnicalFromDate(yearData)
        setTechnicalToDate(dayjs(new Date()))
      }
    }
  }

  const handleTotalenergyGraph = (type, duration, selectedDate) => {
    settTotalEnergyGraphDuration(duration)
    let graphName
    let TechnicalFromDate
    let TechnicalTodate
    switch (duration) {
      case 'year':
        TechnicalFromDate = selectedDate
        TechnicalTodate = 'all'
        break
      case '1m':
        TechnicalFromDate = selectedDate
        TechnicalTodate = 'all'
        break
      case '3m':
        TechnicalFromDate = selectedDate
        TechnicalTodate = 'all'
        break
      case '6m':
        TechnicalFromDate = selectedDate
        TechnicalTodate = 'all'
        break
      case 'mtd':
        TechnicalFromDate = dayjs(new Date())
        TechnicalTodate = 'all'
        break
      case 'ytd':
        TechnicalFromDate = dayjs(new Date())
        TechnicalTodate = 'all'
        break
      case 'custom':
        TechnicalFromDate = selectedDate
        TechnicalTodate = dayjs(technicalToDate).format('YYYY-MM-DD')
        break
      default:
        break
    }

    switch (type) {
      case 'PR':
        graphName = 'PR'
        break
      default:
        break
    }
    setIsLoading(true)
    const sortDate = dayjs(TechnicalFromDate).format('YYYY-MM-DD')

    FetchHomeAvgGraphBysortNew(
      sortDate,
      duration,
      'pr',
      token,
      TechnicalTodate,
      'all'
    ).then((resp) => {
      if (resp?.data) {
        let newEnergyData
        newEnergyData = resp?.data.map((obj) => ({
          x: obj.x,
          y: Number(parseFloat(obj.y).toFixed(1)),
        }))

        setIsLoading(false)
      } else {
      }
    })
  }

  function processGTIAndEnergyData(gtiResponse, energyResponse) {
    const gtiData = gtiResponse || []
    const energyData = energyResponse.data || []
    const result = {
      gti: gtiData.map((gti) => ({
        time: gti.date_time,
        value: gti.value,
      })),

      Yield: energyData.map((energy) => ({
        time: energy.date_time,
        value: energy.value,
      })),
    }

    return result
  }

  // Updated fetchGTIandYieldData function with proper duration formatting
  // const fetchGTIandYieldData = async () => {
  //   const startdate = technicalFromDate.toDate()
  //   const enddate = technicalToDate.toDate()

  //   // Map internal duration format to API expected format
  //     let apiDuration
  //     switch (totalEnergygraphDuration) {
  //       case '1m':
  //         apiDuration = '1M'
  //         break
  //       case '3m':
  //         apiDuration = '3M'
  //         break
  //       case '6m':
  //         apiDuration = '6M'
  //         break
  //       case 'year':
  //         apiDuration = '1Y'
  //         break
  //       case 'ytd':
  //         apiDuration = 'YTD'
  //         break
  //       case 'custom':
  //         apiDuration = 'CUST'
  //         break
  //       case 'mtd':
  //         apiDuration = 'MTD'
  //         break
  //       default:
  //         apiDuration = '1M'
  //     }

  //   // const baseUrl = 'https://staging-backend-v3-express.de.energy'
  //   const baseUrl = 'https://staging-backend-v3-express.de.energy'
  //   const endpoint = `/api/gtiquarterhourlydata/getTotelperfromanceRatio?startDate=${startdate.toISOString()}&endDate=${enddate.toISOString()}&duration=${apiDuration}`

  //   setIsData(false)

  //   try {
  //     const response = await fetch(`${baseUrl}${endpoint}`)

  //     if (!response.ok) {
  //       throw new Error(`HTTP error! Status: ${response.status}`)
  //     }

  //     const data = await response.json()
  //     console.log("dATA",data);
      

  //     // Process the data to ensure it's in the expected format for our components
  //     if (data.success && data.total_pr) {
  //       console.log("data.total_pr",data.total_pr);
        
  //       // Transform the data to the format expected by chart components
  //       const transformedData = data.total_pr
  //       // Filter out entries with zero values
  //       .filter(item => item.aggregatedPR !== 0 && item.totalCapacity !== 0 && item.totalEnergy !== 0)
  //       // Or alternatively, skip just the first entry:
  //       // .slice(1)
  //       .map((item) => ({
  //         period: item.period,
  //         averagePR: item.aggregatedPR, // This is already a percentage value
  //         totalYield: item.totalEnergy || 0,
  //         totalGti: item.totalCapacity || 0,
  //       }));

  //       setMapTotalenergySeries(transformedData)
  //     } else {
  //       // Handle empty or error data
  //       setMapTotalenergySeries([])
  //     }

  //     setIsData(true)
  //   } catch (error) {
  //     console.error('Error fetching aggregated PR data:', error)
  //     setMapTotalenergySeries([])
  //     setIsData(true) // Still set to true to avoid infinite loading
  //   }
  // }

  // Updated fetchGTIandYieldData function in Prgraph.js
/*const fetchGTIandYieldData = async () => {
  const startdate = technicalFromDate.toDate()
  const enddate = technicalToDate.toDate()

  // Map internal duration format to API expected format
  let apiDuration
  switch (totalEnergygraphDuration) {
    case '1m':
      apiDuration = '1M'
      break
    case '3m':
      apiDuration = '3M'
      break
    case '6m':
      apiDuration = '6M'
      break
    case 'year':
      apiDuration = '1Y'
      break
    case 'ytd':
      apiDuration = 'YTD'
      break
    case 'custom':
      apiDuration = 'CUST'
      break
    case 'mtd':
      apiDuration = 'MTD'
      break
    default:
      apiDuration = '1M'
  }

  const baseUrl = 'https://staging-backend-v3-express.de.energy'
  // const baseUrl = 'https://staging-backend-v3-express.de.energy'
  const endpoint = `/api/gtiquarterhourlydata/getTotelperfromanceRatio?startDate=${startdate.toISOString()}&endDate=${enddate.toISOString()}&duration=${apiDuration}`

  setIsData(false)

  try {
    const response = await fetch(`${baseUrl}${endpoint}`)

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`)
    }

    const data = await response.json()
    console.log("Data received:", data);
    
    // Process the data to ensure it's in the expected format for our components
    if (data) {
      // Check if we have a response with buckets structure
      if (data.buckets && Array.isArray(data.buckets)) {
        // Transform the data from the buckets format
        const transformedData = data.buckets
          // Filter out entries with zero values or invalid performance ratios
          .filter(item => item.performanceRatio !== undefined && 
                          item.performanceRatio > 0 && 
                          item.totalYield > 0 && 
                          item.totalIrradiation > 0)
          .map((item) => ({
            period: item.period.split(" to ")[0], // Take the start date of the period
            averagePR: item.performanceRatio * 100, // Convert decimal to percentage
            totalYield: item.totalYield || 0,
            totalGti: item.totalIrradiation || 0,
          }));

        console.log("Transformed data:", transformedData);
        setMapTotalenergySeries(transformedData)
      } 
      // Check if we have a total_pr array structure
      else if (data.total_pr && Array.isArray(data.total_pr)) {
        const transformedData = data.total_pr
          .filter(item => item.aggregatedPR !== 0 && item.totalCapacity !== 0 && item.totalEnergy !== 0)
          .map((item) => ({
            period: item.period,
            averagePR: item.aggregatedPR, // This is already a percentage value
            totalYield: item.totalEnergy || 0,
            totalGti: item.totalCapacity || 0,
          }));

        console.log("Transformed data:", transformedData);
        setMapTotalenergySeries(transformedData)
      }
      // Fallback for direct response without nested structure
      else if (data.aggregatedPerformanceRatio !== undefined) {
        // Handle single period data
        const transformedData = [{
          period: data.period ? data.period.split(" to ")[0] : dayjs().format('YYYY-MM-DD'),
          averagePR: data.aggregatedPerformanceRatio,
          totalYield: data.overallYield || 0,
          totalGti: data.overallIrradiation || 0,
        }];
        
        // Add bucket data if available
        if (data.buckets && Array.isArray(data.buckets)) {
          data.buckets.forEach(bucket => {
            if (bucket.performanceRatio > 0 && bucket.totalYield > 0) {
              transformedData.push({
                period: bucket.period.split(" to ")[0],
                averagePR: bucket.performanceRatio * 100,
                totalYield: bucket.totalYield || 0,
                totalGti: bucket.totalIrradiation || 0,
              });
            }
          });
        }
        
        console.log("Transformed data:", transformedData);
        setMapTotalenergySeries(transformedData)
      } 
      else {
        console.warn("Unexpected data structure:", data);
        setMapTotalenergySeries([])
      }
    } else {
      // Handle empty data
      setMapTotalenergySeries([])
    }

    setIsData(true)
  } catch (error) {
    console.error('Error fetching PR data:', error)
    setMapTotalenergySeries([])
    setIsData(true) // Still set to true to avoid infinite loading
  }
}*/

  //graph-v2 api
  //now fetches aggregated PR value direct from MongoDB, instead of calculating from GTI and Yield.
  const fetchGTIandYieldData = async () => {

    let apiDuration;
    switch (totalEnergygraphDuration) {
      case '1m':
        apiDuration = '1m';
        break;
      case '3m':
        apiDuration = '3m';
        break;
      case '6m':
        apiDuration = '6m';
        break;
      case 'year':
        apiDuration = '1y';
        break;
      case 'ytd':
        apiDuration = 'ytd';
        break;
      case 'custom':
        apiDuration = 'custom';
        break;
      case 'mtd':
        apiDuration = 'mtd';
        break;
      default:
        apiDuration = '1m';
    }
    
    //from date
    const todaydate = totalEnergygraphDuration === 'custom' ? technicalFromDate : dayjs(new Date());
    const fromDateFormatted = todaydate.format('YYYY-MM-DD');
    console.log("FROMDATEFORMATTED", fromDateFormatted);
    
    //all for everythung except custom period
    const toDateParam = totalEnergygraphDuration === 'custom' 
      ? technicalToDate.format('YYYY-MM-DD') 
      : 'all';

    //const endpoint = `/graph-v2/aggregated/pr/${fromDateFormatted}/${apiDuration}/${toDateParam}`;

    setIsData(false);

    try {
      const data = await fetchGraphV2aggr(
        'pr',
        fromDateFormatted,
        apiDuration,
        token,
        toDateParam,
      );
        
      const transformedData = data.map(item => ({
        period: item.x,
        averagePR: item.y,
        totalYield: 0,
        totalGti: 0,
      }));

      setMapTotalenergySeries(transformedData);
      setIsData(true);
    } catch (error) {
      console.error('Error fetching aggregated PR data:', error);
      setMapTotalenergySeries([]);
      setIsData(true);
    }
  };

  useEffect(() => {
    fetchGTIandYieldData()
  }, [technicalFromDate, totalEnergygraphDuration, technicalToDate])

  useEffect(() => {
    fetchGTIandYieldData()
  }, [technicalFromDate, totalEnergygraphDuration])

  return (
    <div className={classes.root}>
      <div
        className="graph_bg"
        style={{ minHeight: '510px', backgroundColor: 'white' }}
      >
        <Dialog fullScreen open={open} onClose={handleClose}>
          <IconButton
            onClick={handleClose}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
          <DialogTitle></DialogTitle>
          <DialogContent>
            <DialogContentText>
              <div className="graph_bg">
                <PrGraphFilter
                  openTable={openTable}
                  setOpenTable={setOpenTable}
                  graphTotalType={graphTotalType}
                  totalEnergygraphDuration={totalEnergygraphDuration}
                  technicalToDate={technicalToDate}
                  technicalFromDate={technicalFromDate}
                  handleChooseDate={handleChooseDate}
                  mapTotalenergySeries={mapTotalenergySeries}
                  h
                  andleOpen={handleOpen}
                  setTechnicalFromDate={setTechnicalFromDate}
                  setTechnicalToDate={setTechnicalToDate}
                  handleTotalenergyGraph={handleTotalenergyGraph}
                  handleGraphupdateOptions={handleGraphupdateOptions}
                />
                <PrGraphContainer
                  openTable={openTable}
                  mapTotalenergySeries={mapTotalenergySeries}
                  chartData={chartData}
                  technicalFromDate={technicalFromDate}
                  totalEnergygraphDuration={totalEnergygraphDuration}
                  technicalToDate={technicalToDate}
                  isData={isData}
                />
              </div>
            </DialogContentText>
          </DialogContent>
        </Dialog>
        <PrGraphFilter
          openTable={openTable}
          setOpenTable={setOpenTable}
          graphTotalType={graphTotalType}
          totalEnergygraphDuration={totalEnergygraphDuration}
          technicalToDate={technicalToDate}
          technicalFromDate={technicalFromDate}
          handleChooseDate={handleChooseDate}
          mapTotalenergySeries={mapTotalenergySeries}
          handleOpen={handleOpen}
          setTechnicalFromDate={setTechnicalFromDate}
          setTechnicalToDate={setTechnicalToDate}
          handleTotalenergyGraph={handleTotalenergyGraph}
          handleGraphupdateOptions={handleGraphupdateOptions}
        />
        <PrGraphContainer
          openTable={openTable}
          mapTotalenergySeries={mapTotalenergySeries}
          chartData={chartData}
          technicalFromDate={technicalFromDate}
          totalEnergygraphDuration={totalEnergygraphDuration}
          technicalToDate={technicalToDate}
          isData={isData}
        />
      </div>
    </div>
  )
}
export default Prgraph
